import { apiSlice } from '@services/apiSlice';
import { ContactUs as endpoints } from '@services/endpoints';
import { FindContactData, ContactUsForm } from './ContactUs.types';

interface FindOfficeQueryParams {
  countryId?: number;
  officeTypeId?: number;
}

interface ContactUsFormQueryParams {
  countryId?: number;
  type?: string;
}

const contactUsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchFindOfficeData: build.query<FindContactData, FindOfficeQueryParams>({
      query: ({ countryId, officeTypeId }) => ({
        url: endpoints.fetchFindOfficeData,
        params: {
          lang: window.lang,
          countryId: countryId || 2000,
          officeTypeId: officeTypeId || 0,
        },
      }),
    }),
    fetchContactUsForm: build.query<ContactUsForm, ContactUsFormQueryParams | void>({
      query: (params) => ({
        url: endpoints.fetchContactUsForm,
        params: {
          lang: window.lang,
          pageId: window.pageId,
          type: params ? params.type : 'RequestAQuote',
          countryId: params && params.countryId ? params.countryId : 0,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useFetchContactUsFormQuery, useLazyFetchFindOfficeDataQuery } = contactUsApi;
